export default "__VITE_ASSET__BtvkiqBC__"